import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../hooks/useUserAccess';

function AdminGuard({ children }) {
  const { isAdmin, loading } = useAdmin();

  if (loading) {
    return (
      <div className="status-card" style={{ textAlign: 'center', padding: 40 }}>
        <span className="status-title">Verificando permissões...</span>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminGuard;